import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import {
  FaArrowRightLong,
  FaChartLine,
  FaCode,
  FaHeadset,
  FaLayerGroup,
  FaNetworkWired,
  FaPeopleArrows,
  FaHospital,
  FaUserShield,
  FaSchool,
  FaGlobe,
  FaComments,
  FaGear
} from "react-icons/fa6";
import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/banner4.jpg";
import banner5 from "../assets/banner5.jpg";
import banner6 from "../assets/banner6.jpg";
import banner7 from "../assets/banner7.jpg";
import banner8 from "../assets/banner8.jpg";
import banner9 from "../assets/banner9.jpg";
import banner10 from "../assets/banner10.jpg";
import banner11 from "../assets/banner11.jpg";
import banner12 from "../assets/banner12.jpg";
import { FaMailBulk } from "react-icons/fa";

export default function ServicesBanner1() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  const services = [
    {
      image: banner1,
      title: "ICT Consulting & Strategy",
      description:
        "Practical roadmaps and advisory support for modernization, planning, and technology investment decisions.",
      icon: <FaChartLine size={28} />,
      navToLink: { item: "services", subItem: "ict-consulting-strategy" },
    },
    {
      image: banner2,
      title: "Systems Integration",
      description:
        "Connecting business systems, data flows, and digital processes into one coordinated operational environment.",
      icon: <FaLayerGroup size={28} />,
      navToLink: { item: "services", subItem: "systems-integration" },
    },
    {
      image: banner3,
      title: "Network Infrastructure Solutions",
      description:
        "Reliable, scalable network foundations designed for security, continuity, and everyday performance.",
      icon: <FaNetworkWired size={28} />,
      navToLink: { item: "services", subItem: "network-infrastructure-solutions" },
    },
    {
      image: banner4,
      title: "Software & Application Development",
      description:
        "Custom applications and digital tools tailored to workflows, reporting needs, and service delivery goals.",
      icon: <FaCode size={28} />,
      navToLink: { item: "services", subItem: "software-application-development" },
    },
    {
      image: banner5,
      title: "IT Support & Maintenance",
      description:
        "Ongoing support, issue resolution, and system care that help teams stay productive and protected.",
      icon: <FaHeadset size={28} />,
      navToLink: { item: "services", subItem: "it-support-maintenance" },
    },
    {
      image: banner6,
      title: "Digital Transformation Solutions",
      description:
        "End-to-end change initiatives that improve efficiency, insight, and long-term organizational agility.",
      icon: <FaPeopleArrows size={28} />,
      navToLink: { item: "services", subItem: "digital-transformation-solutions" },
    },
    // Newly added IT services
    {
      image: banner7,
      title: "Hospital Management Information System (HMIS)",
      description:
        "Integrated healthcare systems for managing patient records, appointments, billing, pharmacy, lab services, and reporting.",
      icon: <FaHospital size={28} />,
      navToLink: { item: "services", subItem: "hmis" },
    },
    {
      image: banner8,
      title: "Biometric Access Control System",
      description:
        "Secure biometric authentication using fingerprint, facial recognition, or iris scanning for physical access control.",
      icon: <FaUserShield size={28} />,
      navToLink: { item: "services", subItem: "biometric-access-control" },
    },
    {
      image: banner9,
      title: "Enterprise Resource Planning (ERP) System",
      description:
        "Custom ERP solutions to streamline finance, procurement, inventory, HR, and supply chain management.",
      icon: <FaGear size={28} />,
      navToLink: { item: "services", subItem: "erp-system" },
    },
    {
      image: banner3,
      title: "School Management Information System (SMIS)",
      description:
        "Digital platform for managing student enrollment, academic records, attendance, exams, fees, and communication.",
      icon: <FaSchool size={28} />,
      navToLink: { item: "services", subItem: "smis" },
    },
    {
      image: banner11,
      title: "Bulk SMS & Event Management System",
      description:
        "Mass communication, notifications, alerts, and event participant coordination via SMS platforms.",
      icon: <FaMailBulk size={28} />,
      navToLink: { item: "services", subItem: "bulk-sms-event-management" },
    },
    {
      image: banner12,
      title: "Web Hosting Services",
      description:
        "Reliable shared, VPS, and dedicated hosting solutions with domain management, SSL, and uptime monitoring.",
      icon: <FaGlobe size={28} />,
      navToLink: { item: "services", subItem: "web-hosting" },
    },
    {
      image: banner1,
      title: "IT Consulting Services",
      description:
        "Expert advisory on system architecture, digital transformation, infrastructure optimization, and cybersecurity.",
      icon: <FaComments size={28} />,
      navToLink: { item: "services", subItem: "it-consulting-services" },
    },
  ];

  // Logic to show only 4 services on home
  const isHome = appContext.navItem === "home" || !appContext.navItem;
  const visibleServices = isHome ? services.slice(0, 3) : services;

  return (
    <section className="MainBodySection nova-section nova-section-soft">
      <div className="container py-5">
        <div className="row justify-content-center text-center mb-5">
          <div className="col-xl-9">
            <h1
              className="font-bold text-secondary"
              data-aos="fade-up"
              data-aos-delay="70"
              style={{ textTransform: "uppercase" }}
            >
              A complete ICT service suite built for growth
            </h1>
            <p className="section-copy" data-aos="fade-up" data-aos-delay="140">
              Nova Technologies provides a comprehensive range of ICT services that help
              organizations streamline operations, strengthen system reliability, and move
              confidently through digital transformation.
            </p>
          </div>
        </div>

        <div className="row g-4 services-grid">
          {visibleServices.map((svc, idx) => (
            <div
              key={svc.title}
              className="col-md-6 col-xl-4"
              data-aos="fade-up"
              data-aos-delay={90 + idx * 60}
            >
              <div
                className="service-card bg-light"
                onClick={() => appContext.navTo(svc.navToLink)}
              >
                <div className="service-card-media">
                  <img src={svc.image} alt={svc.title} />
                </div>
                <div className="service-card-content bg-light">
                  <div className="service-badge">{svc.icon}</div>
                  <h5 className="font-bold">{svc.title}</h5>
                  <p>{svc.description}</p>
                  <span className="service-cta">
                    Explore solution <FaArrowRightLong size={16} />
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {isHome && services.length > 4 && (
          <div className="text-center mt-5">
            <button
              className="btn btn-secondary btn-lg"
              onClick={() => appContext.navTo({ item: "services" })}
            >
              View More Services
            </button>
          </div>
        )}
      </div>
    </section>
  );
}